import { Link, Outlet, useLocation, useNavigate } from "react-router-dom"
import Sidebar from "./Sidebar";
import { useSelector } from "react-redux";
import { motion } from "motion/react";
import jwtDecode from "jwt-decode";
import { useEffect } from "react";

const Layout = ({ children }) => {

    const tknAuth = useSelector((state) => state.tknAuth);

    const navigation = useNavigate()

    useEffect(() => {
        if (!tknAuth?.token) return navigation('/login')
    }, [])

    const location = useLocation();

    let modules = [];
    if (tknAuth) {
        modules = tknAuth.modulos || [];
    }





    return (
        <>
            <div className="d-flex" style={{ minHeight: "100vh", flexDirection: "row" }}>
                {/* Sidebar */}
                <Sidebar modules={modules} />

                {/* Contenido principal */}
                <div className="flex-grow-1 p-4 " style={{ backgroundColor: "#f5f7fa", height: '100vh', overflowY: 'auto' }} key={location.pathname}>
                    {/* Encabezado superior */}
                    <motion.div

                        className="d-flex justify-content-end align-items-center mb-5"
                        style={{
                            paddingRight: "20px",
                        }}
                        initial={{ opacity: 0, scale: 0.8, x: 180 }} // entra desde la derecha real
                        animate={{ opacity: 1, scale: 1, x: 0 }}
                        transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
                        exit={{ opacity: 0, x: 180 }}
                    >
                        <span
                            style={{
                                fontWeight: 600,
                                fontSize: "1rem",
                                color: "#f5f7fa",
                                backgroundColor: "#0a2540",
                                padding: "8px 16px",
                                borderRadius: "25px",
                                boxShadow: "0 2px 6px rgba(10, 37, 64,0.1)",
                            }}
                        >
                            HOLA, {tknAuth?.nombre_completo || "Usuario"}
                        </span>
                    </motion.div>


                    <motion.div
                        //key={location.pathname}
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
                        exit={{ opacity: 0, y: -10 }}
                    >
                        {children}
                        <Outlet />
                    </motion.div>
                </div>
            </div>
        </>
    )

}

export default Layout